import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const TorquePowerRpmCalculatorGuidePage = () => <DataDrivenGuidePage slug="guide-torque-power-rpm-calculator" />;

export default TorquePowerRpmCalculatorGuidePage;
